/**
 *  AdaPay-JS-SDK
 */

var payTool = require('./payTool')
var version = require('./version')

module.exports = {
    version: version.v,
    
    /**
     *  发起支付并监听支付返回结果
     * @param payment  支付数据
     * @param payCallback 支付结果回调 返回结果对象
     */
    doPay: function (payment, payCallback) {
        return payTool.doPay(payment, 120, payCallback)
    },
}

// import payTool from './payTool'
// import version from './version'

// var AdaPay = function () {};

// var sdk = new AdaPay();

// /**
//  *  SDK版本号
//  */
// sdk.version = version.v;

// /**
//  *  发起支付并监听支付返回结果
//  * @param payment  支付数据
//  * @param timeout 结果监听超时时间，默认 120s
//  * @param payCallback 支付结果回调 返回结果对象
//  */
// sdk.doPay = function (payment, timeout=120, payCallback) {
//     return payTool.doPay(payment, timeout, payCallback)
// }

// // exports
// let install = function (Vue, options = {}) {
//     if (install.installed) return;
//     Vue.$AdaPay = Vue.prototype.$AdaPay = sdk;
// };
// if (typeof window !== 'undefined' && window.Vue) {
//     window.Vue.use(install);
// };
// typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = install : window.AdaPay = sdk;


// WEBPACK FOOTER //
// ./src/main.js